import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';
import axios from 'axios';

const initialState = {
  successData: null,
  isAuthenticated: false,
  isAdmin: false,
  loading: false,
  error: null,
};

export const signIn = createAsyncThunk(
  'auth/signIn',
  async (loginData, { rejectWithValue }) => {
    try {
      const basicAuth = btoa(`${loginData.email}:${loginData.password}`);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/users/login`,
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
          },
        },
      );
      return { data: response?.data, status: response?.status };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const forgetPassword = createAsyncThunk(
  'auth/forgetPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/public/forgot-password?email=${encodeURIComponent(email)}`,
        method: 'POST',
      });

      return { data: response?.data, status: response?.status };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const AdminSignin = createAsyncThunk(
  'auth/AdminSignin',
  async (loginData, { rejectWithValue }) => {
    try {
      const basicAuth = btoa(`${loginData.emailId}:${loginData.password}`);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/login`,
        {},
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
          },
        },
      );
      return { data: response?.data, status: response?.status };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);

export const signUp = createAsyncThunk('auth/signUp', async (newUser) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/users/',
      method: 'POST',
      data: newUser,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});

export const NewApplication = createAsyncThunk(
  'auth/applicaiton',
  async (newDetails, { rejectWithValue }) => {
    const data = {
      ...newDetails,
      logo: '',
      mobileServices: Array.isArray(newDetails?.mobileServices) ? true : false,
    };
    const services = Array.isArray(newDetails?.mobileServices)
      ? newDetails?.mobileServices
      : [];
    const serviceObj = services?.reduce((acc, cur) => {
      acc[cur] = true;
      return acc;
    }, {});

    const finalObject = { ...data, ...serviceObj };

    const file = newDetails.logo;
    const fileFormData = new FormData();
    fileFormData.append('data', JSON.stringify(finalObject));
    if (file instanceof File) {
      fileFormData.append('img', file);
      data.logo = fileFormData; // replace file with FormData
    }

    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/public/register',
        method: 'POST',
        data: fileFormData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer null',
        },
      });
      return { status: response.status, data: response?.data };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response?.data,
      });
    }
  },
);
export const checkInstituteId = createAsyncThunk(
  'checkInstituteId',
  async (instituteId) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/public/${instituteId}`,
        method: 'GET',
        headers: {
          Authorization: 'Bearer null',
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const newEmailAcountCreation = createAsyncThunk(
  'auth/signUp',
  async (newLogin) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/users/',
        method: 'POST',
        data: newLogin,
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return { data: error?.response?.data, status: error?.response?.status };
    }
  },
);
export const getAllLoginAccountsDetails = createAsyncThunk(
  'getAllLoginAccountsDetails',
  async () => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/users/all',
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const editLoginAccount = createAsyncThunk(
  'editLoginAccount',
  async (values) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/users/update',
        method: 'PUT',
        data: values,
      });
      return { status: response.status, data: response?.data };
    } catch (error) {
      console.log(error);
    }
  },
);
export const deleteLoginAccount = createAsyncThunk(
  'editLoginAccount',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/users/delete/${id}`,
        method: 'DELETE',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (newPassword) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/users/password-update',
        method: 'PUT',
        data: newPassword,
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const emailCheck = createAsyncThunk('auth/emailCheck', async (email) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/users/emailCheck/${email}`,
      method: 'GET',
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});

export const reportIssue = createAsyncThunk(
  'reportIssue/post',
  async (issueObj) => {
    const formData = new FormData();
    formData.append('attachment', issueObj.attachment);
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/users/chat?issue=${issueObj.issue}`,
        method: 'POST',
        data: formData,
        headers: {
          description: issueObj.description,
          'Content-Type': 'multipart/form-data',
        },
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  },
);
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.isAuthenticated = false;
      state.successData = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.successData = action.payload.data;
        state.error = null;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(AdminSignin.fulfilled, (state) => {
        state.isAdmin = true;
      });
  },
});
export const { logout } = authSlice.actions;
export default authSlice.reducer;
